import React from 'react';
import PropTypes from 'prop-types';

const UserDetailsRow = ({ label, value }) =>
  value && (
    <div>
      <span style={{ fontWeight: 600 }}>{label}: </span>
      <span>{value}</span>
    </div>
  );

UserDetailsRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};

export default UserDetailsRow;
